export default "__VITE_ASSET__DVHyrSXF__"